import { render, staticRenderFns } from "./QuoteActionTransitState.vue?vue&type=template&id=fb5043f8&"
import script from "./QuoteActionTransitState.vue?vue&type=script&lang=ts&"
export * from "./QuoteActionTransitState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports